export enum IPageStatus {
    statusA = 'statusA',
}
